import axios from "axios";

export const forgotPassword = async (userName: string) => {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_API}/Auth/forgot-password`,
      { userName: userName }
    );

    return response;
  } catch (error: any) {
    console.error(error);
    return error.response;
  }
};
